export interface RoundConfig {
  /** Inclusive lower bound for a generated target duration, in milliseconds. */
  minTargetMs: number;
  /** Inclusive upper bound for a generated target duration, in milliseconds. */
  maxTargetMs: number;
  /** Inclusive lower bound for the randomised hidden delay before the clock starts. */
  minPrepareDelayMs: number;
  /** Inclusive upper bound for the randomised hidden delay before the clock starts. */
  maxPrepareDelayMs: number;
}

export interface MatchConfig {
  roundWinsToTakeMatch: number;
  maxRounds: number;
}

export const DEFAULT_ROUND_CONFIG: RoundConfig = {
  minTargetMs: 3_000,
  maxTargetMs: 30_000,
  minPrepareDelayMs: 400,
  maxPrepareDelayMs: 1_600,
};

export const CUSTOM_ROUND_LIMITS: RoundConfig = {
  minTargetMs: 5_00,
  maxTargetMs: 120_000,
  minPrepareDelayMs: 300,
  maxPrepareDelayMs: 2_000,
};

export const DEFAULT_MATCH_CONFIG: MatchConfig = {
  roundWinsToTakeMatch: 3,
  maxRounds: 5,
};

export function clampCustomTargetRange(minTargetMs: number, maxTargetMs: number): RoundConfig {
  const min = Math.min(Math.max(minTargetMs, CUSTOM_ROUND_LIMITS.minTargetMs), CUSTOM_ROUND_LIMITS.maxTargetMs);
  const max = Math.min(Math.max(maxTargetMs, min), CUSTOM_ROUND_LIMITS.maxTargetMs);
  return {
    ...DEFAULT_ROUND_CONFIG,
    minTargetMs: min,
    maxTargetMs: max,
  };
}
